export const CURRENT_SPORK_ROOT = 23830813
export const CURRENT_SPORK_NUMBER = 16
